import { OnDestroy, OnInit } from '@angular/core';
import { InfoProfileService } from '../info-profile.service';
var UserProfileContainerComponent = /** @class */ (function () {
    function UserProfileContainerComponent(infoProfileService) {
        this.infoProfileService = infoProfileService;
    }
    UserProfileContainerComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.userSubscription = this.infoProfileService.getUserProfile().subscribe(function (userProfile) {
            if (userProfile)
                _this.userName = _this.formatUserName(userProfile.userName);
        });
    };
    UserProfileContainerComponent.prototype.openMenu = function () {
        this.menuOpened = true;
    };
    UserProfileContainerComponent.prototype.onCloseMenu = function (closeEvent) {
        this.menuOpened = !closeEvent;
    };
    UserProfileContainerComponent.prototype.ngOnDestroy = function () {
        this.userSubscription.unsubscribe();
    };
    UserProfileContainerComponent.prototype.formatUserName = function (fullName) {
        var result = fullName.split(' ');
        return result[0].trim();
    };
    return UserProfileContainerComponent;
}());
export { UserProfileContainerComponent };
